import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Eyebrow } from './UI';
import { Shield, RefreshCw, Zap, Phone } from 'lucide-react';
export const Guarantee = () => {
  const points = [{
    icon: <Shield className="text-acid-green" size={24} data-id="element-971" data-mp="222dbxl4tkunu" />,
    title: 'LIFETIME STRUCTURAL WARRANTY',
    sub: 'Frame, shell & strap covered — forever.'
  }, {
    icon: <RefreshCw className="text-acid-green" size={24} data-id="element-972" data-mp="19ehe2d3ikwph" />,
    title: '30-DAY FREE RETURNS',
    sub: "Didn't love it? We pick it up at no cost."
  }, {
    icon: <Zap className="text-acid-green" size={24} data-id="element-973" data-mp="14dl53l4b2kd7" />,
    title: '48-HOUR REPLACEMENT',
    sub: 'Valid claims processed in two business days.'
  }, {
    icon: <Phone className="text-acid-green" size={24} data-id="element-974" data-mp="1ed281us6ak5h" />,
    title: 'REAL HUMANS. REAL SUPPORT.',
    sub: 'Call, email, or chat — 7 days a week.'
  }];
  return <section className="bg-gradient-to-b from-dark-1 to-acid-green/5 border-y border-acid-green/10 py-[100px]" data-id="element-975" data-mp="lpohqfizcmuc">
      <div className="container mx-auto px-6 md:px-12" data-id="element-976" data-mp="oygm6gi8jgbc">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-977" data-mp="oxoyrsyskow5">
          {/* Left - Badge */}
          <div className="w-full lg:w-1/3 flex justify-center" data-id="element-978" data-mp="ypb8tlze8hxb">
            <div className="relative w-[320px] h-[320px]" data-id="element-979" data-mp="ypupkzdb509r">
              {/* Corner brackets — pulse */}
              {[{
              pos: 'top-0 left-0',
              rot: 0
            }, {
              pos: 'top-0 right-0',
              rot: 90
            }, {
              pos: 'bottom-0 right-0',
              rot: 180
            }, {
              pos: 'bottom-0 left-0',
              rot: 270
            }].map((c, i) => <motion.div key={i} className={`absolute ${c.pos} w-8 h-8 z-30`} style={{
              transform: `rotate(${c.rot}deg)`
            }} animate={{
              opacity: [0.4, 1, 0.4]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              delay: i * 0.2
            }} data-id="element-980" data-mp="1qfh6phfzm8tk" data-mpi={i}>
                  <div className="absolute top-0 left-0 w-full h-[2px] bg-acid-green" data-id="element-981" data-mp="dgu3ays5xrl" />
                  <div className="absolute top-0 left-0 w-[2px] h-full bg-acid-green" data-id="element-982" data-mp="38rh204yxuey0" />
                </motion.div>)}

              {/* Outer rotating ring with tick marks */}
              <motion.svg viewBox="0 0 200 200" className="absolute inset-0 w-full h-full" animate={{
              rotate: 360
            }} transition={{
              duration: 30,
              ease: 'linear',
              repeat: Infinity
            }} data-id="element-983" data-mp="3iik3h7vs4vxt">
                <circle cx="100" cy="100" r="92" fill="none" stroke="rgba(200,255,0,0.5)" strokeWidth="1" strokeDasharray="2 4" data-id="element-984" data-mp="2l0trrd1jvd8a" />
                {/* Major tick marks every 30deg */}
                {Array.from({
                length: 12
              }).map((_, i) => <line key={i} x1="100" y1="4" x2="100" y2={i % 3 === 0 ? 14 : 10} stroke="#C8FF00" strokeWidth={i % 3 === 0 ? 2 : 1} transform={`rotate(${i * 30} 100 100)`} data-id="element-985" data-mp="1jbd42uy2qmkf" data-mpi={i} />)}
                {/* Cardinal labels */}
                {['N', 'E', 'S', 'W'].map((dir, i) => <text key={dir} x="100" y="22" textAnchor="middle" fill="#C8FF00" fontSize="7" fontFamily="Barlow Condensed, sans-serif" fontWeight="700" transform={`rotate(${i * 90} 100 100)`} data-id="element-986" data-mp="3v2qtvadk7ims" data-mpi={i}>
                    {dir}
                  </text>)}
              </motion.svg>

              {/* Inner counter-rotating ring */}
              <motion.svg viewBox="0 0 200 200" className="absolute inset-0 w-full h-full" animate={{
              rotate: -360
            }} transition={{
              duration: 45,
              ease: 'linear',
              repeat: Infinity
            }} data-id="element-987" data-mp="123dpwpzuy1z0">
                <circle cx="100" cy="100" r="78" fill="none" stroke="rgba(200,255,0,0.25)" strokeWidth="1" data-id="element-988" data-mp="o5fjc6rs39u2" />
                {/* Range gradient marks at 4 quadrants */}
                {[0, 90, 180, 270].map(deg => <g key={deg} transform={`rotate(${deg} 100 100)`} data-id="element-989" data-mp="1tbfbcfj4b548">
                    <line x1="100" y1="22" x2="100" y2="32" stroke="#C8FF00" strokeWidth="1.5" data-id="element-990" data-mp="1xc7mjebjvk35" />
                    <text x="100" y="42" textAnchor="middle" fill="#C8FF00" fontSize="5" fontFamily="Barlow Condensed, sans-serif" data-id="element-991" data-mp="2718zevmstlcw">
                      {deg === 0 ? '300m' : deg === 90 ? '500m' : deg === 180 ? '700m' : '100m'}
                    </text>
                  </g>)}
              </motion.svg>

              {/* Reticle — crosshair + mil-dots — STATIC */}
              <svg viewBox="0 0 200 200" className="absolute inset-0 w-full h-full pointer-events-none" data-id="element-992" data-mp="1p0wizxiwn9ue">
                {/* Vertical crosshair with center gap */}
                <line x1="100" y1="14" x2="100" y2="80" stroke="#C8FF00" strokeWidth="1" data-id="element-993" data-mp="1yw7y4gy86j2o" />
                <line x1="100" y1="120" x2="100" y2="186" stroke="#C8FF00" strokeWidth="1" data-id="element-994" data-mp="27w3d6wuwiy7z" />
                {/* Horizontal crosshair with center gap */}
                <line x1="14" y1="100" x2="80" y2="100" stroke="#C8FF00" strokeWidth="1" data-id="element-995" data-mp="2vobntv1acd3h" />
                <line x1="120" y1="100" x2="186" y2="100" stroke="#C8FF00" strokeWidth="1" data-id="element-996" data-mp="3a8e9xglytgjq" />
                {/* Mil-dots on vertical */}
                {[40, 55, 70, 130, 145, 160].map((y, i) => <circle key={`v${i}`} cx="100" cy={y} r="1.4" fill="#C8FF00" data-id="element-997" data-mp="2rk9d6t3q6vuf" data-mpi={i} />)}
                {/* Mil-dots on horizontal */}
                {[40, 55, 70, 130, 145, 160].map((x, i) => <circle key={`h${i}`} cx={x} cy="100" r="1.4" fill="#C8FF00" data-id="element-998" data-mp="2mk4rmonynaxc" data-mpi={i} />)}
                {/* Tick numbers on vertical (elevation) */}
                <text x="106" y="42" fill="#C8FF00" fontSize="5" fontFamily="Barlow Condensed, sans-serif" data-id="element-999" data-mp="2t1zkgkndtko9">
                  +3
                </text>
                <text x="106" y="162" fill="#C8FF00" fontSize="5" fontFamily="Barlow Condensed, sans-serif" data-id="element-1000" data-mp="2j28rwoidtfqt">
                  -3
                </text>
              </svg>

              {/* Scanning line — vertical sweep */}
              <motion.div className="absolute inset-x-[12%] top-0 h-[1px] bg-gradient-to-r from-transparent via-acid-green to-transparent pointer-events-none" style={{
              boxShadow: '0 0 8px #C8FF00'
            }} animate={{
              y: ['10%', '90%', '10%']
            }} transition={{
              duration: 4,
              ease: 'easeInOut',
              repeat: Infinity
            }} data-id="element-1001" data-mp="20dat3dc4otpp" />

              {/* Center pulsing target */}
              <motion.div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-acid-green pointer-events-none" animate={{
              scale: [1, 1.6, 1],
              opacity: [1, 0.4, 1]
            }} transition={{
              duration: 1.4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} style={{
              boxShadow: '0 0 12px #C8FF00'
            }} data-id="element-1002" data-mp="6wy2ongb3esa" />

              {/* Center content panel — sits on top of reticle */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[160px] h-[160px] flex flex-col items-center justify-center text-center bg-base-black/85 backdrop-blur-sm border border-acid-green/40 z-20" data-id="element-1003" data-mp="2vmxks5df3cw5">
                <Shield className="text-acid-green mb-2" size={28} data-id="element-1004" data-mp="1q0x2d030z8gv" />
                <div className="font-bebas text-[24px] text-white leading-none mb-1" data-id="element-1005" data-mp="1u3a7bm9y72cl">
                  LIFETIME
                  <br data-id="element-1006" data-mp="1z2dbz5m0n6k1" />
                  WARRANTY
                </div>
                <div className="w-10 h-[1px] bg-acid-green/60 my-2" data-id="element-1007" data-mp="241pwhjpf01jg"></div>
                <div className="font-barlow text-[9px] text-acid-green tracking-[2px] uppercase" data-id="element-1008" data-mp="240ya8zhpjg5u">
                  Zero Fine Print
                </div>
              </div>

              {/* HUD readout — top */}
              <motion.div className="absolute -top-2 left-1/2 -translate-x-1/2 font-barlow text-[9px] text-acid-green tracking-[2px] bg-base-black px-2 py-0.5 border border-acid-green/40 z-30" animate={{
              opacity: [0.6, 1, 0.6]
            }} transition={{
              duration: 1.5,
              repeat: Infinity
            }} data-id="element-1009" data-mp="1baprb5fckrq7">
                ● TARGET LOCKED
              </motion.div>

              {/* HUD readout — bottom */}
              <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 font-barlow text-[9px] text-acid-green tracking-[2px] bg-base-black px-2 py-0.5 border border-acid-green/40 z-30" data-id="element-1010" data-mp="g3fbq9x4xoow">
                MAG 4.5× / FOV 8°
              </div>
            </div>
          </div>

          {/* Right - Warranty Dossier */}
          <div className="w-full lg:w-2/3" data-id="element-1011" data-mp="258xcd7sihfm">
            {/* Dossier metadata strip */}
            <div className="flex flex-wrap items-center justify-between gap-3 border-b border-dark-3 pb-3 mb-6" data-id="element-1012" data-mp="3tilkjp13wzfx">
              <div className="flex items-center gap-3 font-barlow text-[10px] tracking-[2px] text-text-dimmed uppercase" data-id="element-1013" data-mp="3okjyqwcaqm0r">
                <span className="text-acid-green" data-id="element-1014" data-mp="3jmifobevempa">●</span>
                <span data-id="element-1015" data-mp="3elug31cksxjg">FILE 004 — WARRANTY DOCTRINE</span>
                <span className="hidden md:inline text-dark-3" data-id="element-1016" data-mp="3enf8olfby6eo">|</span>
                <span className="hidden md:inline" data-id="element-1017" data-mp="3akixvgw17ela">STATUS: ACTIVE</span>
              </div>
              <div className="font-barlow text-[10px] tracking-[2px] text-acid-green uppercase" data-id="element-1018" data-mp="2zy42sn9xbjrn">
                ENFORCED BY BLACKOUT UNIT TEAM
              </div>
            </div>

            <Eyebrow data-id="element-1019" data-mp="2qz903l638rt3">OUR COMMITMENT</Eyebrow>
            <h2 className="text-4xl md:text-[52px] leading-[0.95] mb-6" data-id="element-1020" data-mp="2r0ae9yiehuf1">
              WE BACK EVERY BLACKOUT UNIT™{' '}
              <span className="text-acid-green" data-id="element-1021" data-mp="3jn4toh0d23ln">FOR LIFE.</span>
            </h2>

            {/* Pull-quote block */}
            <div className="border-l-2 border-acid-green pl-5 py-1 mb-8 max-w-2xl" data-id="element-1022" data-mp="3nozw5ou12n10">
              <p className="font-barlow font-bold text-[12px] text-acid-green tracking-[2px] uppercase mb-3" data-id="element-1023" data-mp="39xbgjbkklgfa">
                — Field Doctrine —
              </p>
              <div className="font-barlow text-[16px] md:text-[17px] text-text-body leading-[1.85] space-y-3" data-id="element-1024" data-mp="3eubm7ldich5v">
                <p data-id="element-1025" data-mp="6ei8tfeh3lt1">
                  "We built the BLACKOUT UNIT Ultimate Mask to last a lifetime —
                  and we back that claim with a warranty that does the same.
                </p>
                <p data-id="element-1026" data-mp="kjijh5p1zuft">
                  If your mask ever fails under normal use, we replace it. No
                  forms. No wait. No runaround. No 'submit a ticket and wait 14
                  business days.' One call. One email. Handled.
                </p>
                <p className="text-white font-medium" data-id="element-1027" data-mp="pdwh7er6udnn">
                  Because operators don't have time for fine print — and neither
                  do we."
                </p>
              </div>
            </div>

            {/* Numbered commitment list — tactical dossier style */}
            <div className="border border-dark-3 bg-dark-1" data-id="element-1028" data-mp="bm869esodv89">
              {/* Header row */}
              <div className="hidden md:grid grid-cols-[60px_120px_1fr_140px] items-center gap-4 px-5 py-2.5 border-b border-dark-3 bg-base-black" data-id="element-1029" data-mp="6l2djgz0m7yq">
                <div className="font-barlow text-[10px] text-text-dimmed tracking-[2px]" data-id="element-1030" data-mp="1n26mq3q6njji">
                  CLAUSE
                </div>
                <div className="font-barlow text-[10px] text-text-dimmed tracking-[2px]" data-id="element-1031" data-mp="3nq2vxu61lfze">
                  SCOPE
                </div>
                <div className="font-barlow text-[10px] text-text-dimmed tracking-[2px]" data-id="element-1032" data-mp="3sp5xh4mtd42m">
                  PROVISION
                </div>
                <div className="font-barlow text-[10px] text-text-dimmed tracking-[2px] text-right" data-id="element-1033" data-mp="5jy8rl0n7h7r">
                  STATUS
                </div>
              </div>

              {points.map((p, i) => {
              const scope = ['STRUCTURAL', 'RETURNS', 'REPLACEMENT', 'SUPPORT'][i];
              return <div key={i} className="group grid grid-cols-[40px_1fr_auto] md:grid-cols-[60px_120px_1fr_140px] items-center gap-4 px-5 py-4 border-b border-dark-3 last:border-b-0 hover:bg-base-black transition-colors relative" data-id="element-1034" data-mp="p7np8w34pv1o" data-mpi={i}>
                    {/* Left accent bar on hover */}
                    <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-acid-green opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1035" data-mp="2is7ixejw7egr" />

                    <div className="font-bebas text-[22px] text-acid-green leading-none" data-id="element-1036" data-mp="29pojl4fbfjz9">
                      {String(i + 1).padStart(2, '0')}
                    </div>
                    <div className="hidden md:flex items-center gap-2 font-barlow text-[11px] text-acid-green tracking-[2px]" data-id="element-1037" data-mp="24sy5gmn2mygh">
                      {p.icon && cloneElement(p.icon as React.ReactElement, {
                    size: 14
                  })}
                      {scope}
                    </div>
                    <div data-id="element-1038" data-mp="2nqiuputqzz1m">
                      <h4 className="font-bebas text-[18px] text-white leading-none mb-1" data-id="element-1039" data-mp="2np7rbw47stb1">
                        {p.title}
                      </h4>
                      <p className="font-inter text-[12px] text-text-dimmed leading-snug" data-id="element-1040" data-mp="3geoeae92fhzv">
                        {p.sub}
                      </p>
                    </div>
                    <div className="hidden md:flex justify-end items-center gap-1.5 font-barlow text-[10px] text-acid-green tracking-[2px]" data-id="element-1041" data-mp="37c5ji53tnhh">
                      <span className="w-1.5 h-1.5 rounded-full bg-acid-green animate-pulse" data-id="element-1042" data-mp="3qj4vbaya7559" />
                      ENFORCED
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
};